// src/pages/PanelNotificaciones.jsx

import React from 'react';
import { useNotifications } from '../hooks/useNotifications';
import { useAuthCliente } from '../context/AuthClienteContext';
import {
  Box,
  Heading,
  VStack,
  HStack,
  Text,
  Tag,
  Button,
  Divider,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale/es';

export default function PanelNotificaciones() {
  const { notifications = [], markAllAsRead } = useNotifications(); 
  const toast = useToast();

  const handleMarkAll = async () => {
    try {
      await markAllAsRead();
      toast({ title: 'Todas las notificaciones marcadas como leídas', status: 'success', duration: 3000 });
    } catch (err) {
      console.error(err);
      toast({ title: 'Error al marcar notificaciones', status: 'error', duration: 3000 });
    }
  };

  // La data del usuario se obtiene del hook, no es necesario aquí
  if (notifications === undefined) {
    return (
      <Box p={8} textAlign="center">
        <Spinner size="xl" />
        <Text mt={4}>Cargando notificaciones...</Text>
      </Box>
    );
  }

  return (
    <Box p={{ base: 4, md: 8 }}>
      <HStack mb={4} justify="space-between">
        <Heading>Panel de Notificaciones</Heading>
        <Button colorScheme="blue" onClick={handleMarkAll} isDisabled={notifications.every(n => n.read)}>
          Marcar todas como leídas
        </Button>
      </HStack>
      <VStack spacing={4} align="stretch">
        {notifications.length === 0 ? (
          <Text color="gray.600" p={4} bg="gray.50" borderRadius="md" textAlign="center">
            No tienes notificaciones registradas.
          </Text>
        ) : (
          notifications.map((notif) => (
            <Box key={notif.id} p={4} bg={notif.read ? 'white' : 'blue.50'} borderRadius="md" shadow="sm" borderWidth="1px" borderColor={notif.read ? 'gray.200' : 'blue.200'}>
              <VStack align="stretch" spacing={2}>
                <HStack justifyContent="space-between">
                  <Text fontSize="lg" fontWeight={notif.read ? 'normal' : 'bold'}>{notif.message}</Text>
                  <Tag size="sm" colorScheme={notif.read ? 'gray' : 'blue'}>
                    {notif.read ? 'Leída' : 'Nueva'}
                  </Tag>
                </HStack>
                
                {/* ✅ AQUÍ MOSTRAMOS LOS DETALLES */}
                {notif.details && (
                  <Text color="gray.700" pl={1}>{notif.details}</Text>
                )}

                <HStack justify="space-between" align="center" mt={1}>
                  <Text fontSize="xs" color="gray.500">
                    {notif.createdAt?.toDate
                      ? formatDistanceToNow(notif.createdAt.toDate(), { addSuffix: true, locale: es })
                      : ''}
                  </Text>
                  {notif.dismissed && (
                    <Tag size="xs" colorScheme="red">
                      Descartada del menú
                    </Tag>
                  )}
                </HStack>
              </VStack>
            </Box>
          ))
        )}
      </VStack>
    </Box>
  );
}